import { render, staticRenderFns } from "./interactive-external-player-controls.vue?vue&type=template&id=767f9552&scoped=true&"
import script from "./interactive-external-player-controls.vue?vue&type=script&lang=js&"
export * from "./interactive-external-player-controls.vue?vue&type=script&lang=js&"
import style0 from "./interactive-external-player-controls.vue?vue&type=style&index=0&id=767f9552&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767f9552",
  null
  
)

export default component.exports